import React, { FunctionComponent } from 'react';
// import { useHistory } from 'react-router-dom';

import Icon from '../Icons';

import { Container } from './Header.styled';

const Header: FunctionComponent<{ title: string; link?: string; history?: any }> = ({
  children,
  history,
  title = 'Dashboard',
  link,
}) => {
  // const history: any = useHistory();
  const opid_trucking = window.localStorage.getItem('opid_trucking');
  return (
    <Container>
      <header className="main-header">
        <div className="container">
          <div className="mh-logo" onClick={() => history.push(link)}>
            {opid_trucking === '331' ? (
              <div className="customised_331">
                <Icon name="logo_331" />
              </div>
            ) : (
              <Icon name="logo" />
            )}
            <h1 className="title largest fwsb">{title}</h1>
          </div>
          <nav className="main-nav">{children}</nav>
        </div>
      </header>
    </Container>
  );
};

export default Header;
